export const baseUrl = `${window.CLIENT_RAZOR_ENV ? 'https://dev.offroadeq.com' : ''}/umbraco/api/`;
const delay = window.CLIENT_RAZOR_ENV ? 500 : 0;

function request({method,url,data,id,action,naked}){
    let canceled = false,
        promise = new Promise( (resolve,reject) => {
            var xhr = new XMLHttpRequest();
            xhr.onload = function(){
                if (xhr.status >= 200 && xhr.status < 300) {
                    if(!canceled) setTimeout( () => resolve(response()), delay);
                } else {
                    error(xhr.status);
                }            
            }
            xhr.onerror = xhr.onabort = error;
            function error(status){
                if(!canceled) reject(response() || {ExceptionMessage:'Cannot connect to server, please try again in a few minutes.'});
                switch(status) {
                    case 401: 
                        window.location.href="/login/";
                        break;
                }
            }
            function response(){
                return typeof xhr.response === 'string' ? JSON.parse(xhr.response) : xhr.response;
            }
            xhr.open(url.indexOf('.json') === -1 ? method : 'GET', 
                (url.indexOf('.json') === -1 && url.indexOf('https://') === -1 ? baseUrl : '') + 
                url + 
                (url.indexOf('.json') === -1 && !naked ? '/' + method : '') + 
                (id ? '/' + id : '') + (action ? (url.indexOf('.json') === -1 ? '/' : '') + action : '')
            );
            xhr.setRequestHeader('Accept','application/json, text/plain, */*');
            xhr.setRequestHeader('Content-Type','application/json;charset=UTF-8');
            xhr.withCredentials = true;
            xhr.responseType = 'json';
            xhr.send(data ? JSON.stringify(data) : undefined);    
        });
        promise.cancel = function(){
            canceled = true;
        };
    return promise;
}

function makeQuery(params,prepend = ''){
    let keys = Object.keys(params);
    return keys.length > 0 ? 
        prepend + keys.map(key => key + '=' + params[key]).join('&')
        : '';
}

function localTest(url,data = {},action=''){
    //return url;
    return window.CLIENT_RAZOR_ENV ? `/scripts/endpoints/${url + (data.type || '') + action}.json` : url;
}

export function get(url,data = {}){
    return request({method:'GET',url:localTest(url,data),action:makeQuery(data,'?')});
}

export function create(url,data){
    return request({method:'POST',url:localTest(url,data,'Create'),data});
}

export function remove(url,data){
    return request({method:'DELETE',url:localTest(url,data,'Remove'),action:makeQuery(data,'?')});
}

export function save(url,data) {
    return request({method:'PUT',url:localTest(url,data,'Save'),data});
}

export function auth(url,data){
    return request({method:'POST',url,data,naked:true});
}